module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "contact-form",
      "name": "contact-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.name),
      expression: "contacto.name"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": _vm.tr('enter_name')
    },
    domProps: {
      "value": (_vm.contacto.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.email),
      expression: "contacto.email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": _vm.tr('enter_email')
    },
    domProps: {
      "value": (_vm.contacto.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contacto.message),
      expression: "contacto.message"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "message",
      "placeholder": _vm.tr('enter_message')
    },
    domProps: {
      "value": (_vm.contacto.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contacto.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": "6LcjPS4UAAAAAIXm8SZCShzsHZILirdHdlVQ_VfU"
    },
    on: {
      "verify": _vm.onVerify
    }
  }, [_c('button', {
    staticClass: "button btn_lg btn_blue btn_full upper",
    class: {
      'disabled': !_vm.valid
    },
    attrs: {
      "disabled": !_vm.valid,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.send($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-location-arrow"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "lang",
      rawName: "v-lang.send_message",
      modifiers: {
        "send_message": true
      }
    }]
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445cc80b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactForm/Simple.vue
// module id = 361
// module chunks = 0